import React from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';

export const StoreCardSeperator: React.FC = () => {
  return <Box minWidth="0.25rem" width="0.25rem" maxWidth="0.25rem" />;
};
